<template>
  <div id="modal" ref="modal" @mousedown="closeModal">
    <transition name="zoom">
      <div
        ref="modal-content"
        v-if="showModalContent"
        class="content-part"
        :style="modalSizes"
        @mousedown.stop
      >
        <div class="basic-modal-header" v-if="component.title">
          <span class="kaushan-font title"> {{ component.title }}</span>
          <close-icon
            v-if="
              (component.closeIcon === true ||
                component.closeIcon === undefined) &&
                component.bind.closeable !== false
            "
            class="close-icon"
            @closeIconClicked="closeModal"
          />
        </div>
        <!-- <perfect-scrollbar ref="ps-scroll"> -->
        <div class="basic-modal-content" ref="basic-modal-content">
          <div
            class="modal-wrapper custom-scrollbar"
            ref="modal-content-wrapper"
          >
            <component
              :is="component.bind.is"
              v-bind="component.bind"
              v-on="component.on"
            ></component>
          </div>
        </div>
        <!-- </perfect-scrollbar> -->
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    component: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showModalContent: false
    };
  },
  created() {
    this.showModal();
    window.addEventListener("keyup", this.handleKeyup);
  },
  mounted() {},
  beforeDestroy() {
    window.removeEventListener("keyup", this.handleKeyup);
  },
  methods: {
    handleKeyup(event) {
      if (event.key === "Escape") {
        this.closeModal();
      }
    },
    showModal() {
      setTimeout(() => {
        this.showModalContent = true;
        setTimeout(() => {
          if (!this.component.title) {
            this.$refs["basic-modal-content"].style.height = "100%";
          } else {
            this.$refs["basic-modal-content"].style.height =
              "calc(100% - 40px)";
            setTimeout(() => {
              // this.$refs["modal-content-wrapper"].style["overflow-y"] = "auto";
            }, 1500);
          }
        }, 250);
      }, 100);
    },
    closeModal() {
      if (this.component.bind.closeable !== false) {
        this.showModalContent = false;
        setTimeout(() => {
          this.$eventBus.closeModal();
        }, 500);
      }
    }
  },
  computed: {
    modalSizes() {
      const width = this.component.bind.width
        ? this.component.bind.width
        : "fit-content";
      const height = this.component.bind.height
        ? this.component.bind.height
        : "fit-content";
      return {
        height,
        width
      };
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#modal {
  width: 100vw !important;
  height: 100vh !important;
  position: fixed;
  top: 0;
  left: 0;
  z-index: $Z-modal;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.2);
  .content-part {
    max-width: 95vw;
    max-height: 95vh;
    position: relative;
    background: #fff;
    border-radius: 10px;
    box-shadow: $input-shadow;
    .basic-modal-header {
      position: relative;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 10px;
      .title {
        font-size: 22px;
      }
      .close-icon {
        position: absolute;
        right: 10px;
      }
    }
    .basic-modal-content {
      width: 100%;
      overflow: hidden;
      .modal-wrapper {
        height: 100%;
        // height: calc(100% - 40px);
      }
    }
  }
}
// .basic-modal-content::-webkit-scrollbar {
//   display: none !important;
// }
// .basic-modal-content {
//   -ms-overflow-style: none !important; /* IE and Edge */
//   scrollbar-width: none !important; /* Firefox */
// }
</style>
